
import { timeRangeOptions, saleOrderStatus, stateOptionBoolean } from "@/utils/options";
import { InboundOrderEnum } from "modules/warehouse/inbound-order/enum";

const dateTypeOptions = [
    {id: 'createDate', text: '创建时间'}
]

export default () => [{
    prop: 'name',
    label: '视图名称',
    isFormItem: true,
    components() {
        return [{
            name: 'gj-input',
            prop: 'name',
            propsData: {
                placeholder: '请输入视图名称',
                style: {
                    width: '256px'
                }
            }
        }]
    },
    validator: [
        {required: true, message: '请输入视图名称', trigger: 'change'}
    ],
    labelWidth: '120px',
    defaultValue: ''
}, {
    label: '状态',
    prop: 'statusList',
    components: [{
        name: 'gj-select',
        prop: 'statusList',
        propsData: {
            placeholder: '状态',
            options: InboundOrderEnum.statusOption,
            multiple: true,
            collapseTags: true
        },
        style: {
            width: '150px'
        }
    }],
    isFormItem: true,
    labelWidth: '120px',
    defaultValue: []
}, {
    label: '供应商',
    prop: 'supplier',
    isFormItem: true,
    labelWidth: '120px',
    components: [{
        name: 'gj-supplier-select',
        prop: 'supplier',
        propsData: {
            placeholder: '供应商'
        }
    }],
    defaultValue: ''
}, {
    label: '入库仓',
    prop: 'deliveryWarehouseId',
    isFormItem: true,
    labelWidth: '120px',
    components: [{
        name: 'gj-warehouse-select',
        prop: 'deliveryWarehouseId',
        propsData: {
            fba: false,
            placeholder: '入库仓'
        },
        style: {
            width: '150px'
        }
    }],
    defaultValue: ''
},{
    label: '创建人',
    prop: 'createUser',
    isFormItem: true,
    labelWidth: '120px',
    components: [{
        name: 'gj-creator-select',
        prop: 'createUser',
        propsData: {
            placeholder: '创建人'
        }
    }],
    defaultValue: ''
},  {
    label: '时间范围',
    prop: 'dateRange',
    isFormItem: true,
    labelWidth: '120px',
    components: [{
        name: 'gj-select',
        prop: 'dateType',
        propsData: {
            placeholder: '时间类型',
            options: dateTypeOptions
        }
    }, {
        name: 'gj-select',
        prop: 'dateRange',
        propsData: {
            placeholder: '时间范围',
            options: timeRangeOptions,
            style: {
                marginLeft: '8px'
            }
        }
    }],
    validator: [
        {required: true, message: '请选择日期', trigger: 'change'}
    ]
}, {
    prop: 'dateType',
    defaultValue: 'createDate'
}]
